import { theme } from '@orobix/orobix-fe-components'
import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles((t: typeof theme) => ({
  modal: {
    position: 'fixed',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    zIndex: t.zIndexModal,
    width: '100%',
    height: '100%',
    outline: 0,
    backgroundColor: t.white,
    opacity: 1,
    animation: '$show .3s ease',

    '@supports ((-webkit-backdrop-filter: none) or (backdrop-filter: none))': {
      backdropFilter: 'blur(1rem)',
      backgroundColor: 'rgba(255, 255, 255, 1)',
    },
  },

  '@keyframes show': {
    '0%': {
      display: 'none',
      opacity: 0,
    },
    '1%': {
      display: 'block',
      opacity: 0,
    },
    '100%': {
      opacity: 1,
    },
  },

  modalOpen: {
    overflow: 'hidden',
  },

  modalContainer: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
  },

  modalHeader: {
    display: 'flex',
    flexFlow: 'row nowrap',
    justifyContent: 'space-between',
    position: 'relative',
  },

  modalContent: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
  },

  title: {
    display: 'block',
    fontSize: '1.25rem',
    marginTop: ' 0.65625rem', // (45px (close button height) - 24px (title font size)) / 2
    marginLeft: '1rem',
  },
}))

export { useStyles }
